import axios from '@axios'
import { exec } from 'child_process';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('inline_tags', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            axios.get(`buyers/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('buyers', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`tickets/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`tickets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        sale_growers: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('sale_growers', { params: params})
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        buy: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('inline_buying', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        transports: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('user_transports', { params: params})
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        tickets: (cntx, { id }) => {
            return new Promise((resolve, reject) => {
                axios.get(`transport_tickets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        runBatFile: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('run_allow', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}
